import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const heading = css`
  ${responsiveText.BODY.MD};
  margin: 0 0 ${spacing.md}px;
`;

export const content = css`
  p {
    ${responsiveText.BODY.MD};
    margin: 0 0 ${spacing.xl}px;
  }
`;
